import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { faCog, faPlus, faSearch, faEllipsisV, faPowerOff, faArrowUp, faArrowDown, faPen, faEdit, faTrash, faShareAlt, faFolderPlus, faFileExport, faFileImport, faFolderOpen, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { SharedService } from '../helper/shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login/login.service';
import { ConfirmationdialogueService } from '../confirmationdialogue/confirmationdialogue.service';
import { HomeService } from './home.service';
import { ToastrService } from 'ngx-toastr';
import { isNullOrEmpty } from '../helper/validation';
import { formatDate, Location } from '@angular/common';
import { LocalizedString } from '@angular/compiler';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserInfoService } from '../user-info/user-info.service';
import { ProjectService } from "../project/project.service";
import { ProgramSettingsService } from '../program-settings/program-settings.service'; //Modified by PP(2023-02-14) : If Load Project, unit in contamination page:Program Settings is missing
import { createPopper } from '@popperjs/core';  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  @ViewChild('templateShare', { static: false }) shareModal: any;
  faCog = faCog;
  faPlus = faPlus;
  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  faSearch = faSearch;
  faPowerOff = faPowerOff;
  faFileImport = faFileImport;
  faFileExport = faFileExport;
  faFolderPlus = faFolderPlus;
  faFolderOpen = faFolderOpen;
  faTrash = faTrash;
  faEdit = faEdit;
  faShareAlt = faShareAlt;
  faPen = faPen;
  faEllipsisV = faEllipsisV;
  faInfoCircle = faInfoCircle;  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)
  orderby = 'Asc';
  orderBytitle = 'name';
  displaySortByTitles = "";
  currentFolderName = "";
  viewFlag = "";
  sharedProjectName = "";
  fname = '';
  ftype = '';
  URL = '';

  currentFolderID = 0;
  appId = 0;
  fid = 0;
  fParentId = 0;

  loading = true;
  exportMultipleProject = false;

  fileSelected: any = [];
  path: any = [];
  projects: any;
  allProjects: any;
  allRecentProjects: any;
  recentProjects: any;
  newFolderName = '';
  files: any = [];
  filesEvent: any = [];
  team: any;
  emailTeam: any = [];
  link: any;
  appDesc: any;
  closeResult: string;
  copyInfo: any;   //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)
  sendInfo: any;   //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)

  constructor(
    private router: Router,
    private confirmationDialogService: ConfirmationdialogueService,
    private activated: ActivatedRoute,
    private toastr: ToastrService,
    private loginService: LoginService,
    private sharedService: SharedService,
    private projectService: ProjectService,
    private modalService: NgbModal,
    private homeService: HomeService,
    private userInfoService: UserInfoService,
    public programSettingService: ProgramSettingsService) { } //Modified by PP(2023-02-14) : If Load Project, unit in contamination page:Program Settings is missing

  ngOnInit(): void {
    this.appDesc = "MCCLD Online";
    this.appId = this.sharedService.ApplicationID;
    this.orderby = 'Asc';

    if (this.sharedService.token == '') {
      this.sharedService.token = this.loginService.cookieSvc.get("CFSSLoginCode");
    } else if (this.sharedService.token !== '') {
      this.loginService.cookieSvc.set("CFSSLoginCode", this.sharedService.token);
    }

    //this.path.push({'Title': 'Root', 'ID': 0});
    this.path.push({ 'Title': 'Home', 'ID': 0 });
    this.loading = true;
    this.getProjects();
    this.initializeTeam(false);
    this.loading = false;
    this.sharedService.showSaveButton = false;
    this.projectService.projectdetails.NewPath = ''; // check this
    this.sharedService.FromProgramSettings = false; //Modified by PP(2023-02-28) : If click on new project then go back to Home -> Program settings, title becomes Untitled Project  
  }

  ngOnDestroy() {
    this.sharedService.GoToUsersClickPath = true;
    this.sharedService.SavedUserClickPath = [];
    for (var i = 0; i < this.path.length; i++) {
      let tmpRec = {
        ID: this.path[i].ID,
        Title: this.path[i].Title
      }
      this.sharedService.SavedUserClickPath.push(tmpRec);
    }
  }

  ngOnChanges() {
    var abc = 123;
  }

  ngAfterContentInit() {
    var abc = 123;
  }

  ngAfterViewInit() {
    var abc = 123;
  }

  selectView(data: any) {
    this.viewFlag = data;
    if (data == 'Recent') {
      if (this.recentProjects !== undefined) {
        if (this.sharedService.AutoSave && this.sharedService.FinishedAutoSaveToDB) {
          this.getRecentProject();
          this.sharedService.AutoSave = false;
          this.sharedService.FinishedAutoSaveToDB = false;
        }
        this.projects = this.recentProjects;
      } else {
        this.getRecentProject();
      }
    }
    else {
      if (this.sharedService.AutoSave && this.sharedService.FinishedAutoSaveToDB) {
        this.getProjects();
        this.sharedService.AutoSave = false;
        this.sharedService.FinishedAutoSaveToDB = false;
      } else {
        this.projects = this.allProjects;
        this.sort('name');
      }
    }
  }

  initializeTeam(needToClose: any) {
    this.team = [{
      "Name": "",
      "Email": ""
    },
    {
      "Name": "",
      "Email": ""
    },
    {
      "Name": "",
      "Email": ""
    }
    ];

    //Share XML
    if (needToClose) {
      this.modalService.dismissAll();
    }
  }

  getProjects() {
    let userId = this.userInfoService.userData.UserId;
    if (userId === 0) {
      this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe(usrAccountInfo => {
        //Modified by PP(2023-10-24): Check for timeout of logincode - START
        if (usrAccountInfo !== null) {
          if (usrAccountInfo !== undefined) {
            this.sharedService.detectUserBrowser();
            this.userInfoService.InsertUserData(usrAccountInfo);
            this.sharedService.RetrieveDDL();
            console.log("PS20230321 Check: => Update App Usage - START=> " + new Date());
            this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'LOGON').subscribe(result => {
              console.log("PS20230321 Check: => Update App Usage - END=> " + new Date());
              if (result) {

              }
            });

            this.getFolder(0, "Home");
            this.getRecentProject();
          }
        } else {
          this.sharedService.redirectToLoginPage();
          // this.userInfoService.userData.UserId = 0;
          // this.loginService.cookieSvc.set("CFSSLoginCode", '');
          // this.toastr.error('Session time out. Please login again.', '');
          // this.router.navigate(["login"]);
        }
        //Modified by PP(2023-10-24): Check for timeout of logincode - END

      });
    } else {
      this.getFolder(0, "Home"); // Get Root Folder
      this.getRecentProject();
    }
  }

  getFolder(pFolderID: number, pFolderName: string) {
    console.log("PS20230321 Check: => fetch app folders -START => " + new Date());
    this.sharedService.GetApplicationFolder(pFolderID, true).subscribe(
      res => {
        console.log("PS20230321 Check: => fetch app folders -END => " + new Date());

        //Modified by PP(2023-10-24): Check for timeout of logincode - START
        if (res !== undefined && res !== null) {
          if (res.ID == 0 && res.ParentID == 0 && res.TotalFile == 0 && res.childFolder.length == 0) {
            //this.toastr.warning('No saved projects in your profile.', '');
            this.loading = false;
          } else {
            this.sharedService.AllFilesAndFolders = res;

            // Assign Folders and Files into Front End Structure
            let payload = this.sharedService.assignToNewFolderStruc(pFolderID);

            this.viewFlag = 'All';
            this.allProjects = payload;

            this.allProjects.forEach(function (element: any) {
              try {
                element['newDate'] = formatDate(element.TimeStamp, "dd MMMM yyyy", 'en-US');;
              } catch {
                element['newDate'] = element.TimeStamp.substring(0, element.TimeStamp.indexOf(" "));
              }
            });

            this.projects = this.allProjects;
            this.sort(this.orderBytitle);

            if (pFolderID > 0) {
              // Modified by JW(2023-03-31):RNDS-116 #9, change the deleting process, stay in the folder-start
              //this.path.push({'Title': pFolderName, 'ID': pFolderID});
              if (this.path.length > 0) {
                const foundFolderId = this.path.find(item => item.ID === pFolderID);
                if (!foundFolderId) {
                  this.path.push({ 'Title': pFolderName, 'ID': pFolderID });
                }
              }
              // Modified by JW(2023-03-31):RNDS-116 #9, change the deleting process, stay in the folder-end
            } else {
              this.popPathArray(0);
            }

            this.currentFolderID = pFolderID;
            this.sharedService.currentFolderID = pFolderID;
            this.currentFolderName = pFolderName;
            this.loading = false;
          }
        } else {
          this.loading = false;
          this.sharedService.redirectToLoginPage();
          // this.userInfoService.userData.UserId = 0;
          // this.toastr.error('Session time out. Please login again.', '');
          // this.router.navigate(["login"]); 
        }
        //Modified by PP(2023-10-24): Check for timeout of logincode - END
      },
      err => {
        this.toastr.error('Failed to retrieve the save projects. Please try again.', '');
        this.loading = false;
      }
    );
  }

  changeOrder(data: string) {
    this.orderby = data;
    this.sort(this.orderBytitle);
  }

  logout() {
    let ConfirmHead = "Confirmation";
    let Confirmbody = "Do you really want to logout?";
    this.confirmationDialogService.confirm(ConfirmHead, Confirmbody)
      .then((confirmed) => {
        localStorage.removeItem('CFSSLoginCode');
        this.loginService.setCookie('');
        this.userInfoService.userData.UserId = 0;
        this.router.navigate(['login'], { queryParams: { ApplicationID: this.sharedService.ApplicationID } });
      })
      .catch(() => console.log('User dismissed the dialog'));
  }

  rename(pItem: any) {
    this.fname = pItem.Fname;
    this.ftype = pItem.Type;
    this.fid = pItem.ID;
    this.fParentId = pItem.ParentID;
  }

  RenameThis(newName: string, pType: string, pID: number, pParentID: number) {
    if (pType === "Folder") {
      this.sharedService.EditFolder(pID, pParentID, newName).subscribe(data => {
        if (data !== null) {
          if (data.Process.Fail === false) {
            this.toastr.success('Renamed successfully', '');
            this.getProjects();
          } else {
            if (data.Process.Message === '') {
              this.toastr.warning('Something went wrong when renaming of folder', '');
            } else {
              this.toastr.warning(data.Process.Message, '');
            }
          }
        } else {
          this.sharedService.redirectToLoginPage();
        }
      })
    }
    if (pType === "File") {
      this.sharedService.EditFile(pID, newName).subscribe(data => {
        if (data !== null) {
          if (data.Process.Fail === false) {
            this.toastr.success('Renamed successfully', '');
            this.getProjects();
          } else {
            if (data.Process.Message === '') {
              this.toastr.warning('Something went wrong when renaming of file', '');
            } else {
              this.toastr.warning(data.Process.Message, '');
            }
          }
        } else {
          this.sharedService.redirectToLoginPage();
        }
      })
    }
  }

  openChild(id: any) {
    this.getFolder(id.ID, id.Fname);
  }

  sort(sortBy: string) {
    this.orderBytitle = sortBy;

    switch (sortBy) {
      case "name":
        this.displaySortByTitles = "Sort by [name]";
        break;

      case "date":
        this.displaySortByTitles = "Sort by [Date]";
        break;
    }

    if (sortBy === 'date') {
      this.projects.sort((a, b) => {
        var dateA: any = +new Date(a.TimeStamp);
        var dateB: any = +new Date(b.TimeStamp);

        if (this.orderby == 'Dsc') {
          return dateB - dateA;
        } else {
          return dateA - dateB;
        }
      });
    }

    if (sortBy === 'name') {
      if (this.projects != undefined) {
        this.projects.sort((a, b) => {
          if (a.Type !== 'Folder' && b.Type !== 'Folder') {
            var nameA = a.Fname.toLowerCase(), nameB = b.Fname.toLowerCase();
          }

          if (this.orderby == 'Asc') {
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            } else {
              return 0;
            }
          } else {
            if (nameA > nameB) {
              return -1;
            } else if (nameA < nameB) {
              return 1;
            } else {
              return 0;
            }
          }
        });
      }
    }

    // If above all right, then include sort by name
  }

  editProject(id: number) {
    this.loading = true;
    let pathString = '';
    if (this.path.length > 0) {
      this.path.forEach(function (element: any) {
        pathString += element.Title + '/'
      });
    } else {
      pathString = 'home';
    }

    let selected = this.projects.filter(function (item: any) {
      return item.ID == id;
    });

    if (selected[0].Path !== '' && selected[0].Path !== undefined) {
      let pFolder = selected[0].Path.split('\\');
      if (pFolder.length > 0) {
        pathString = '';
        for (let i = 0; i < pFolder.length; i++) {
          if (pFolder[i] !== '') {
            pathString += pFolder[i] + '/';
          }
        }
      }
    }

    if (selected.length > 0) {
      this.sharedService.ProjectToEdit = {
        id: id,
        name: selected[0].Fname
      }
    } else {
      this.sharedService.ProjectToEdit = {
        id: id,
        name: "Project"
      }
    }

    //this.sharedService.headerProjectName = this.sharedService.ProjectToEdit.name;
    //this.sharedService.calculationType = 'CLD'; //Default to CLD for loadproject even if it's astm record. only in results.component.ts then only segregate out
    //this.sharedService.PathStringFromHomeComponent = pathString; //For Load ASTM
    console.log("before callLoadProjectApi " + this.sharedService.ProjectToEdit.name);
    console.log("PS20230321 Check: => load selected record -START=> " + new Date());
    this.projectService.callLoadProjectApi(id, true).subscribe(data => {
      console.log("PS20230321 Check: => load selected record -END=> " + new Date());
      if (data !== null) {
        if (data) {
          this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'LOADCALCULATION').subscribe(result => {                       
            if (result) {}
          });
          var loadFromDB: any = data;
          if (loadFromDB.Process.Fail == false) {
            this.sharedService.loadFromDatabase = data;
            this.toastr.success('Project Loaded successfully', '');
            this.sharedService.blnLoadFromRecord = true;

            if (loadFromDB.Params.ExportType == 'Incomplete') {
              this.sharedService.projectNotCalc = true;
            } else {
              this.sharedService.projectNotCalc = false;
            }

            this.getProgramSettingsData(); //Modified by PP(2023-02-14) : If Load Project, unit in contamination page:Program Settings is missing

            this.sharedService.calculationType = loadFromDB.Params.CalcType; //ASTM or CLD
            this.projectService.projectdetails.NewPath = '';
            this.sharedService.headerProjectName = loadFromDB.Params.ProjectInfo.ProjectName;

            //pplim: trial
            //triggerDoneFromProgSettings();

            this.router.navigate(['/projectedit', id], { queryParams: { path: pathString } });
          } else {
            if (loadFromDB.Process.Message != '') {
              this.sharedService.blnLoadFromRecord = false;
              this.loading = false;
              this.toastr.warning(loadFromDB.Process.Message, '');
            } else {
              this.sharedService.blnLoadFromRecord = false;
              this.loading = false;
              this.toastr.warning('Something went wrong when loading of project', '');
            }
          }
        } else {
          this.sharedService.blnLoadFromRecord = false;
          this.loading = false;
        }
      } else {
        this.sharedService.blnLoadFromRecord = false;
        this.loading = false;
        this.sharedService.redirectToLoginPage();
      }
    })
  }

  newProject() {
    let pathString = '';
    if (this.path.length > 0) {
      this.path.forEach(element => {
        pathString += element.Title + '/'
      });
    }
    else {
      pathString = 'home';
    }

    this.sharedService.ProjectToEdit = {
      id: 0,
      name: "New Project"
    }

    this.router.navigate(['/newProject'], { queryParams: { path: pathString } });
    this.sharedService.VisibleSaveClass = 'HideSaveClass';
  }

  goTofolder(item: any, index: number) {
    if (index == 0) {
      this.getProjects();
      this.popPathArray(index);
    }
    else if (index != this.path.length - 1) {
      this.openChild(item);
      this.popPathArray(index);
    }
  }

  popPathArray(index: number) {
    for (let i = this.path.length - 1; i > index; i--) {
      this.path.pop();
    }
  }

  deleteProject(pItem: any) {
    if (pItem.Type === 'File') {
      let ConfirmHead = "Confirmation";
      let Confirmbody = "Do you really want to delete?";
      this.confirmationDialogService.confirm(ConfirmHead, Confirmbody)
        .then((confirmed) =>
          this.sharedService.DeleteFile(pItem.ID, true).subscribe(data => {
            if (data !== null) {
              if (data.Process.Fail === false) {
                this.toastr.success('Project deleted', '');
                this.getFolder(this.currentFolderID, this.currentFolderName);
                this.getRecentProject(); //Bugs. If deleted a project, recentprojects array is still old array. Didn't reflect the new projects available
              }
              else {
                this.toastr.warning('Something went wrong', '');
              }
            } else {
              this.sharedService.redirectToLoginPage();
            }

          }))
        .catch(() => console.log('User dismissed the dialog'));
    }

    if (pItem.Type === 'Folder') {
      let ConfirmHead = "Confirmation";
      let Confirmbody = "Do you really want to delete?";
      this.confirmationDialogService.confirm(ConfirmHead, Confirmbody)
        .then((confirmed) =>
          this.sharedService.DeleteFolder(pItem.ID, pItem.ParentID).subscribe(data => {
            if (data !== null) {
              if (data.Process.Fail === false) {
                this.toastr.success('Project deleted', '');
                this.popPathArray(0);
                this.getProjects();
              }
              else {
                this.toastr.warning('Something went wrong', '');
              }
            } else {
              this.sharedService.redirectToLoginPage();
            }
          }))
        .catch(() => console.log('User dismissed the dialog'));
    }
  }

  addRow() {
    if (this.team.length < 10) {
      let team = {
        "Name": "",
        "Email": ""
      }
      this.team.push(team);
    }
  }

  generateLink(id) {
    this.loading = true;
    var ProjectID = [];
    ProjectID.push(parseInt(id));

    this.projectService.exportToXML(ProjectID, "Complete").subscribe(exportResultData => {
      if (exportResultData !== null) {

        if (exportResultData) {

          this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'EXPORTCALCULATION').subscribe(result => {                       
            if (result) {}
          });
          this.link = exportResultData.URL;
          this.sharedProjectName = exportResultData.ProjectName;
          this.loading = false;
          this.modalService.open(this.shareModal, {
            ariaLabelledBy: 'modal-basic-title',
            centered: true,
            size: 'lg',
            backdrop: 'static'
          }).result.then((result) => {

          }, (reason) => {
            this.closeResult = `Dismissed`;
          });
          this.toastr.success("Project exported", "");
        } else {
          this.loading = false;
          this.toastr.warning("Something went wrong when exporting of project", "");
        }
      } else {
        this.loading = false;
        this.sharedService.redirectToLoginPage();
      }
    })
  }

  copyLink(link: any) {
    link.select();
    document.execCommand('copy');
    this.toastr.success('Link copied successfully', '');
  }

  //pplim
  copyLink2(s: string) {
    navigator.clipboard.writeText(s).then(() => {
      this.toastr.success('Link copied successfully', '');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  onFileDropped(event: any) {
    this.files = [];
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      const elementType = element.type;
      if (elementType.includes("xml") || elementType.includes("zip")) {
        this.files.push(element.name);
        this.filesEvent = event;
      }
      else {
        this.toastr.warning('You can upload XML/ZIP only in file format', ''); // Modified by PP(2020-12-18) : To cater for Zip Files
      }
    }
  }

  deleteAttachment(index: number) {
    this.files.splice(index, 1)
  }

  import() {
    let proceed = true;
    this.loading = true;
    if (isNullOrEmpty(this.URL) && this.files.length == 0) {
      proceed = false;
      this.toastr.warning('Files And Link Are Not Available', '');
    }

    if (!isNullOrEmpty(this.URL) && this.files.length > 0) {
      proceed = false;
      this.toastr.warning('Please remove the URL', '');
    }

    if (proceed) {
      // URL
      if (!isNullOrEmpty(this.URL)) {
        this.projectService.importFromXML(this.files, this.URL).subscribe(data => {
          //Modified by PP(2023-10-24): Check for timeout of logincode - START
          if (data !== null && data !== undefined) {

            this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'IMPORTCALCULATION').subscribe(result => {                       
              if (result) {}
            });

            this.loading = false;
            var importFromXMLData: any = data;
            if (importFromXMLData.Process.Fail == false) {
              this.sharedService.importXMLData = data;
              this.toastr.success('Project imported', '');

              this.sharedService.ProjectToEdit = {
                id: importFromXMLData.Params.ProjectInfo.ProjectID,
                name: importFromXMLData.Params.ProjectInfo.ProjectName
              }

              this.sharedService.blnLoadFromRecord = true;
              this.sharedService.LoadingXML = true;

              if (importFromXMLData.Params.ExportType == 'Incomplete') {
                this.sharedService.projectNotCalc = true;
              } else {
                this.sharedService.projectNotCalc = false;
              }

              this.sharedService.calculationType = importFromXMLData.Params.CalcType; //ASTM or CLD
              this.sharedService.headerProjectName = importFromXMLData.Params.ProjectInfo.ProjectName;
              this.getProgramSettingsData(); //Modified by PP(2023-02-14) : If Load Project, unit in contamination page:Program Settings is missing
              this.router.navigate(['/importxml', importFromXMLData.Params.ProjectInfo.ProjectID], { queryParams: { path: 'Home/' } });
            } else {
              if (importFromXMLData.Process.Message != '') {
                this.toastr.warning(importFromXMLData.Process.Message, '');
              } else {
                this.toastr.warning('Something went wrong when importing of project', '');
              }
            }
          } else { //Modified by PP(2021-01-07) : Bugs
            this.sharedService.LoadingXML = false; //Modified by PP(2021-01-07) : Bugs
            this.loading = false;
            this.sharedService.redirectToLoginPage();
            // this.userInfoService.userData.UserId = 0;
            // this.toastr.error('Session time out. Please login again.', '');
            // this.router.navigate(["login"]); 
          }
          //Modified by PP(2023-10-24): Check for timeout of logincode - END
        }) // importFromXML


        const divCancel = document.getElementById('divCancelImport');
        divCancel?.click();
      }

      // Files
      if (this.files.length > 0) {
        this.sharedService.UploadFileToServer(this.filesEvent).subscribe(UploadFileToServerData => {
          var tmpRes: any = UploadFileToServerData;
          if (tmpRes.Message == 'Success' && tmpRes.TotalSaved > 0) {
            this.projectService.importFromXML(this.files, "").subscribe(data => {
              //Modified by PP(2023-10-24): Check for timeout of logincode - START
              if (data !== null && data !== undefined) {

                this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'IMPORTCALCULATION').subscribe(result => {
                  if (result) {}
                });

                this.loading = false;
                var importFromXMLData: any = data;
                if (importFromXMLData.Process.Fail == false) {
                  this.sharedService.importXMLData = data;
                  this.toastr.success('Project imported', '');

                  if (importFromXMLData.Params.ProjectID == undefined || importFromXMLData.Params.ProjectID == null) {
                    importFromXMLData.Params.ProjectID = 0;
                  }

                  this.sharedService.ProjectToEdit = {
                    id: importFromXMLData.Params.ProjectID,
                    name: importFromXMLData.Params.ProjectInfo.ProjectName
                  }

                  this.sharedService.LoadingXML = true;

                  if (importFromXMLData.Params.ExportType == 'Incomplete') {
                    this.sharedService.projectNotCalc = true;
                  } else {
                    this.sharedService.projectNotCalc = false;
                  }

                  this.getProgramSettingsData(); //Modified by PP(2023-02-14) : If Load Project, unit in contamination page:Program Settings is missing
                  //this.sharedService.blnLoadFromRecord = true;
                  this.sharedService.calculationType = importFromXMLData.Params.CalcType; //ASTM or CLD
                  this.sharedService.headerProjectName = importFromXMLData.Params.ProjectInfo.ProjectName;
                  //this.router.navigate(['/importxml',importFromXMLData.Params.ProjectID], { queryParams: { path  : 'Root/'}});
                  this.router.navigate(['/importxml', importFromXMLData.Params.ProjectID], { queryParams: { path: 'Home/' } });
                } else {
                  if (importFromXMLData.Process.Message != '') {
                    this.toastr.warning(importFromXMLData.Process.Message, '');
                  } else {
                    this.toastr.warning('Something went wrong during importing of project', '');
                  }
                }
              } else {
                this.sharedService.LoadingXML = false;
                this.loading = false;
                this.sharedService.redirectToLoginPage();
                // this.userInfoService.userData.UserId = 0;
                // this.toastr.error('Session time out. Please login again.', '');
                // this.router.navigate(["login"]); 
              }
              //Modified by PP(2023-10-24): Check for timeout of logincode - END

            }) // importFromXML
          } else {
            this.loading = false;
          }
        }) //UploadFileToServer

        const divCancel = document.getElementById('divCancelImport');
        divCancel?.click();
      } //if (this.files.length > 0)
    } //if (proceed)
  }

  newFolder() {
    this.newFolderName = "";
  }

  createFolder(NewFolderName: string) {
    if (NewFolderName != '') {
      this.sharedService.CreateNewFolder(this.currentFolderID, NewFolderName).subscribe(data => {

        //Modified by PP(2023-10-24): Check for timeout of logincode - START
        if (data !== null) {
          if (data.Process.Fail === false) {
            this.toastr.success('Folder created successfully', '');
            this.path.push({ 'Title': 'Home', 'ID': 0 });
            let indexToPop = 0;
            for (var x = 0; x < this.path.length; x++) {
              if (this.path[x].ID == this.currentFolderID) {
                indexToPop = x;
              }
            }
            this.popPathArray(indexToPop - 1);
            this.getFolder(this.currentFolderID, this.currentFolderName); // Get Root Folder
          } else {
            this.toastr.warning('Something went wrong during creation of folder', '');
          }
        } else {
          this.sharedService.redirectToLoginPage();
          // this.userInfoService.userData.UserId = 0;
          // this.toastr.error('Session time out. Please login again.', '');
          // this.router.navigate(["login"]); 
        }
        //Modified by PP(2023-10-24): Check for timeout of logincode - END

      })
    } else {
      this.toastr.warning('Folder name cannot be empty', '');
    }
  }

  getRecentProject() {
    console.log("PS20230321 Check: => getRecentProject-START => " + new Date());
    this.sharedService.getRecentProjects().subscribe(
      recentfiles => {
        console.log("PS20230321 Check: => getRecentProject-END => " + new Date());
        if (recentfiles !== null) {
          if (recentfiles !== undefined) {
            if (recentfiles.Files != undefined) {
              if (recentfiles.Files.length > 0 && recentfiles.TotalFile !== 0) {

                // Modified by JW(2023-03-31): RNDS-116 #10, change Root to Home-start
                const filesOfRecentFiles = recentfiles.Files;
                const stringToFind = "ROOT";
                const replacementString = "Home";
                let newfileswithHome = [];
                for (let i = 0; i < recentfiles.Files.length; i++) {
                  const index = recentfiles.Files[i].Path.indexOf(stringToFind);
                  if (index !== -1) {
                    let strPath = recentfiles.Files[i].Path;
                    let newpath = strPath.replace(stringToFind, replacementString);
                    recentfiles.Files[i].Path = newpath;
                  }
                }
                // Modified by JW(2023-03-31): RNDS-116 #10, change Root to Home-end

                this.sharedService.AllRecentFiles = recentfiles;
                let payload = this.sharedService.assignRecentFilesToNewFolderStruc();
                this.allRecentProjects = payload;

                this.allRecentProjects.forEach(function (element: any) {
                  try {
                    element['newDate'] = formatDate(element.TimeStamp, "dd MMMM yyyy", 'en-US');;
                  } catch {
                    element['newDate'] = element.TimeStamp.substring(0, element.TimeStamp.indexOf(" "));
                  }
                });

                this.recentProjects = this.allRecentProjects;
                this.projects = this.recentProjects;
                this.sharedService.autoSaveProject = undefined;
                if (this.projects !== undefined) {
                  if (this.projects.length > 0) {
                    for (var x = 0; x < this.projects.length - 1; x++) {
                      let tmp = this.projects[x];
                      if (tmp.Fname === this.sharedService.autoSaveDefaultProjectName) {
                        this.sharedService.autoSaveProject = tmp;
                        break;
                      }
                    }
                  }
                }

                if (this.loading === true) {
                  this.viewFlag = 'All';
                  this.selectView('All');
                } else {
                  if (this.viewFlag == 'Recent') {
                  } else {
                    this.viewFlag = 'All';
                    this.selectView('All');
                  }
                }
              }
            } else { //Modified by PP(2022-03-30) : If no files and folders at all - START
              this.recentProjects = undefined;
              this.projects = undefined;
              this.allRecentProjects = undefined;
            } //Modified by PP(2022-03-30) : If no files and folders at all - END
          }
        } else {
          this.sharedService.redirectToLoginPage();
        }
      }
    );
  }

  sendEmail() {
    var fail = false;
    this.emailTeam = [];
    var noEmail = 0;
    this.loading = true;

    if (this.team.length == 0) {
      fail = true;
      this.toastr.warning("Unable to send Email Out. Team Members must not be empty", "");
    }

    for (var x = 0; x < this.team.length; x++) {
      if (this.team[x].Email == "" && this.team[x].Name == "") {
        noEmail = noEmail + 1;
      }
    }
    if (noEmail == this.team.length) {
      fail = true;
      this.toastr.warning("Unable to send Email Out. Team Members must not be empty", "");
    }

    if (!fail) {
      for (var x = 0; x < this.team.length; x++) {
        if (this.team[x].Email == "" && this.team[x].Name != "") {
          fail = true;
          this.toastr.warning("Email Cannot Be Blank", "");
          break;
        }

        if (!fail) {
          if (this.team[x].Name == "" && this.team[x].Email != "") {
            fail = true;
            this.toastr.warning("Name Cannot Be Blank", "");
            break;
          }
        }

        //Modified by PP(2023-09-13) : To validate email address. User has keyed in Atiyeh, Ahmad <Ahmad.Atiyeh@camfil.com> - START       
        if (this.team[x].Email != "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          var testResult = emailRegex.test(this.team[x].Email);
          if (testResult) {
            fail = false;
          } else {
            fail = true;
            this.toastr.warning("Invalid Email Address on " + this.team[x].Email, "");
            break;
          }
        }
        //Modified by PP(2023-09-13) : To validate email address. User has keyed in Atiyeh, Ahmad <Ahmad.Atiyeh@camfil.com> - END
      }
    }

    if (!fail) {
      for (var x = 0; x < this.team.length; x++) {
        if (this.team[x].Email != "" && this.team[x].Name != "") {
          let tmpTeam = {
            "Name": this.team[x].Name,
            "Email": this.team[x].Email
          }
          this.emailTeam.push(tmpTeam);
        }
      }
      this.triggerPrepareSendEmail();
    } else {
      this.loading = false;
    }
  }

  triggerPrepareSendEmail() {
    var Data: any = {};
    Data.EmailTeam = this.emailTeam;
    this.sharedService.CountTotalSeqForUploadingParams(Data, "UPLOAD LCC PARAMS TO SERVER");
    this.PrepareToUploadParams();
  }

  PrepareToUploadParams() {
    var dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
      res => {
        console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
        if (res) {
          this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
          this.sharedService.ServerDataReady = true;
          this.sharedService.UploadingEntry = false;
          if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
            this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
            this.PrepareToUploadParams();
          } else {
            if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
              this.projectService.emailURL(this.emailTeam, this.link, this.sharedProjectName).subscribe(emailed => {
                if (emailed !== null) {
                  if (emailed) {

                    this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'EMAILPROJECT').subscribe(result => {                       
                      if (result) {}
                    });

                    this.loading = false;
                    this.toastr.success("Email has been sent", "");
                    this.modalService.dismissAll();
                  } else {
                    this.loading = false;
                    this.toastr.warning("Something went wrong when emailing of URL", "");
                  }
                } else {
                  this.sharedService.redirectToLoginPage();
                }
              });
            } else {
              this.loading = false;
              this.toastr.error("Failed to upload Parameters for Emailing. TotalPass <> TotalSeq.", "");
            }
          }
        } else {
          this.loading = false;
          this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
          this.sharedService.UploadingEntry = false;
          this.sharedService.ServerDataReady = false;
          this.toastr.error("Failed to upload Parameters for Emailing. TotalFail>1.", "");
        }
      },
      err => {
        this.toastr.warning("Failed to upload Parameters for Emailing. Please try again.", "");
      }
    );
  }

  showShow(pIndex) {
    const div = document.getElementById('cardMore' + pIndex);
    if (div.classList.contains('show')) {
      div.classList.remove("show");
    } else {
      div.classList.add("show");
    }
  }

  getProgramSettingsData() {
    if (this.programSettingService.unitList === undefined) {
      var selUnit = 0;
      selUnit = this.userInfoService.userData.UserUnitId;
      if (selUnit > 0) {
        console.log("PS20230321 Check: => fetch program settings -START=> " + new Date());
        this.programSettingService.getData(selUnit).subscribe((result) => {
          console.log("PS20230321 Check: => fetch program settings -END=> " + new Date());
          if (result !== null) {
            if (result !== undefined) {
              this.programSettingService.unitList = result.Selection.UnitsList;
            }
          } else {
            this.sharedService.redirectToLoginPage();
          }
        });
      }
    }
  }

  search(data) {
    var SearchValue = "";
    switch (this.sharedService.userBrowser) {
      case "chrome":
        //SearchValue = data.path[0].value;
        SearchValue = data.currentTarget.value;
        break;

      case "firefox":
        SearchValue = data.currentTarget.value;
        break;

      case "edge": //Modified by PP(2023-01-18) : New Edge browser is edg
        SearchValue = data.target.value;
        break;

      // case "opera":

      // break;

      // case "ie":

      // break;

      // case "safari":

      // break;

      default:
        SearchValue = data.path[0].value;
        break;
    }
    this.projects = this.allProjects.filter(x => {
      return x.Fname.toLowerCase().includes(SearchValue.toLowerCase())
    });
  }

  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-start
  showHideInfoToggle(field: string) {
    switch (field) {
      case 'copy':
        let CopyInfo = document.getElementById('CopyInfoBtn');
        let CopyInfoToolTip = document.getElementById('CopyInfo');
        this.createPop(CopyInfo, CopyInfoToolTip);
        if (this.copyInfo) {
          CopyInfoToolTip.removeAttribute("data-show");
          this.copyInfo = false;
        } else {
          CopyInfoToolTip.setAttribute("data-show", "");
          this.copyInfo = true;
        }
        break;
      case 'send':
        let SendInfo = document.getElementById('SendInfoBtn');
        let SendInfoToolTip = document.getElementById('SendInfo');
        this.createPop(SendInfo, SendInfoToolTip);
        if (this.sendInfo) {
          SendInfoToolTip.removeAttribute("data-show");
          this.sendInfo = false;
        } else {
          SendInfoToolTip.setAttribute("data-show", "");
          this.sendInfo = true;
        }
        break;
    }
  }

  createPop(ref: any, popper: any) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
  }
  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-end
}
